import {
  ViewEncapsulation, Injectable, Component,
  OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter
} from "@angular/core";

@Component({
  selector: "app-opti2k5k-detail",
  templateUrl: "./opti2k5k-detail.component.html",
  styleUrls: ["./opti2k5k-detail.component.css"]
})
export class Opti2k5kDetailComponent implements OnInit, OnChanges {
  @Input() Item: any = undefined;
  constructor() { }
  public renderFail(onoff: boolean) {
    return onoff ? "故障" : "正常";
  }
  public renderWarn(onoff: boolean) {
    return onoff ? "警告" : "正常";
  }
  public renderFailCSS(onoff: boolean) {
    return onoff ? "bg-danger" : "bg-success";
  }
  public renderWarnCSS(onoff: boolean) {
    return onoff ? "bg-warning" : "bg-success";
  }
  public render2or1(tiggerv: boolean, onoff: boolean) {
    if (tiggerv) {
      return this.renderFail(onoff);
    }
    return this.renderWarn(onoff);
  }
  public render2or1CSS(tiggerv: boolean, onoff: boolean) {
    if (tiggerv) {
      return this.renderFailCSS(onoff);
    }
    return this.renderWarnCSS(onoff);
  }
  public renderOutputMode(mode: string): string {
    switch (mode) {
      case "0":
        return "單機輸出";
      case "1":
        return "並聯輸出";
      case "2":
        return "Phase 1 of 3 phase output";
      case "3":
        return "Phase 2 of 3 phase output";
      case "4":
        return "Phase 3 of 3 phase output";
    }
    return mode;
  }
  public getInverterDeviceMode(mode: string) {
    switch (mode) {
      case "P":
        return `開機中 (Power on)`;
      case "B":
        return `電池 (Battery)`;
      case "S":
        return `待機 (Standby)`;
      case "L":
        return `市電 (Line)`;
      case "F":
        return `故障 (Fault)`;
      case "H":
        return `省電 (Power saving)`;
      default:
        return mode;
    }
  }
  public renderOutputSourcePriority(mode: number): string {
    switch (mode) {
      case 0:
        return "(Utility First) 市電優先";
      case 1:
        return "(Solar First) 太陽能優先";
      case 2:
        return "(SBU First) 太陽能-電池-市電";
    }
    return mode.toString();
  }
  public renderChargerSourcePriority(mode: string): string {
    switch (mode) {
      case "0":
        return "(Utility First) 市電優先";
      case "1":
        return "(Solar First) 太陽能優先";
      case "2":
        return "(Solar Utility) 市電合併太陽能";
      case "3":
        return "(Only Solar) 只有太陽能";
    }
    return mode;
  }
  ngOnInit() {

  }
  async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {

  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/ESS-BA20GA30IGW/opti2k5k-detail/opti2k5k-detail.component.ts